// @flow

import * as React from "react";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import { password } from "@constants/Validators";

type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const PasswordMedicalPortalForm = (props: PropsType): React.Node => {
    return (
        <ReactForm
            validators={[password]}
            pageSubmit
            method="POST"
            action={props.action || ""}
        >
            <ReactFormField
                type="password"
                name="password"
                required={true}
                validators={["vaxiplace-password"]}
                errorMessages={{
                    required: "Please enter a password.",
                }}
                label="Password"
            />

            <button type="submit" className="button button--wide">
                Submit
            </button>

            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default PasswordMedicalPortalForm;
